import type { DriveStep } from 'driver.js';

export { sharedDriverConfig } from './tour-config';

import { attorneyCasesSteps } from './attorney-cases';
import { attorneyDashboardSteps } from './attorney-dashboard';
import { attorneyIntakeSteps } from './attorney-intake';
import { attorneyInvoicesSteps } from './attorney-invoices';
import { attorneySettingsSteps } from './attorney-settings';
import { doctorBillingSteps } from './doctor-billing';
import { doctorCasesSteps } from './doctor-cases';
import { doctorDashboardSteps } from './doctor-dashboard';
import { doctorInvoicesSteps } from './doctor-invoices';
import { doctorPreScreeningSteps } from './doctor-pre-screening';
import { doctorSettingsSteps } from './doctor-settings';

// Re-export step arrays for direct use by individual components
export {
  attorneyCasesSteps,
  attorneyDashboardSteps,
  attorneyIntakeSteps,
  attorneyInvoicesSteps,
  attorneySettingsSteps,
  doctorBillingSteps,
  doctorCasesSteps,
  doctorDashboardSteps,
  doctorInvoicesSteps,
  doctorPreScreeningSteps,
  doctorSettingsSteps,
};

export interface TourDefinition {
  id: string;
  label: string;
  steps: DriveStep[];
  /** The view/route to navigate to before starting (for Help menu) */
  route?: string;
}

export const doctorTours: TourDefinition[] = [
  {
    id: 'doctor-dashboard',
    label: 'Dashboard Tour',
    route: 'dashboard',
    steps: doctorDashboardSteps,
  },
  {
    id: 'doctor-pre-screening',
    label: 'Pre-Screening Tour',
    route: 'requests',
    steps: doctorPreScreeningSteps,
  },
  { id: 'doctor-cases', label: 'Cases Tour', route: 'cases', steps: doctorCasesSteps },
  { id: 'doctor-invoices', label: 'Invoices Tour', route: 'invoices', steps: doctorInvoicesSteps },
  { id: 'doctor-billing', label: 'Billing Tour', route: 'billing', steps: doctorBillingSteps },
  { id: 'doctor-settings', label: 'Settings Tour', route: 'settings', steps: doctorSettingsSteps },
];

export const attorneyTours: TourDefinition[] = [
  {
    id: 'attorney-dashboard',
    label: 'Dashboard Tour',
    route: 'dashboard',
    steps: attorneyDashboardSteps,
  },
  {
    id: 'attorney-intake',
    label: 'Intake Tour',
    route: 'intake-requests',
    steps: attorneyIntakeSteps,
  },
  { id: 'attorney-cases', label: 'Cases Tour', route: 'cases', steps: attorneyCasesSteps },
  {
    id: 'attorney-invoices',
    label: 'Invoices Tour',
    route: 'invoices',
    steps: attorneyInvoicesSteps,
  },
  {
    id: 'attorney-settings',
    label: 'Settings Tour',
    route: 'settings',
    steps: attorneySettingsSteps,
  },
];
